import styled from "styled-components";
import { colors } from "@/theme";

interface DealerInfoContainerProps {
  $textAlign?: string;
}

export const DealerInfoContainer = styled.div<DealerInfoContainerProps>`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 42px;
  font-style: normal;
  font-weight: 500;
  ${(props) => !!props.$textAlign && `text-align: ${props.$textAlign};`}
`;

export const DealerInfoData = styled.p`
  margin: 1px 0px;
`;
